import { initializeForm } from "../../utils/formSubmission";

/**
 * Initializes the cmo.exchange contact form with reCAPTCHA integration.
 * This function sets up the form when Webflow is ready, configuring it with
 * the appropriate form ID, endpoint, and reCAPTCHA site key.
 * 
 * The form initialization includes:
 * - Setting up event listeners
 * - Configuring form visibility
 * - Handling reCAPTCHA verification
 * - Managing form submission
 * 
 * @returns {void}
 */
export function initializeCmoConsultationForm(): void {
  // Initialize the form when Webflow is ready
  window.Webflow ||= [];
  window.Webflow.push(() => {
    initializeForm("consultation-form", "Cmo", "6LcrY-oqAAAAALonxUtz7LUWPmUNZYWa0uC8vA9o");
    console.log("initializeForm", initializeForm)
  });
}